import { render, staticRenderFns } from "./EstimatedDevEffort.vue?vue&type=template&id=e8dcfdbe&scoped=true&"
import script from "./EstimatedDevEffort.vue?vue&type=script&lang=js&"
export * from "./EstimatedDevEffort.vue?vue&type=script&lang=js&"
import style0 from "./EstimatedDevEffort.vue?vue&type=style&index=0&id=e8dcfdbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dcfdbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VMenu,VTextField})
